// extracted by mini-css-extract-plugin
module.exports = {"flexLayout":"reviews-module--flexLayout--3S1tQ","header":"reviews-module--header--1ESZG","carousel":"reviews-module--carousel--3akpX"};